<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'common.title_info_date'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";
import { format } from "date-fns";

export default {
  name: "StorageLossRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: { type: Object, required: true },
    saving: { type: Boolean, default: false },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "stock_management.transactions.date",
          path: "storage_loss_date",
          required: true,
          formatter: (val) => (val ? format(new Date(val), "dd-MM-yyyy") : "*"),
        },
        {
          labelKey: "common.legal_entity_name",
          path: "legal_entity_name",
          required: true,
        },
        {
          labelKey: "common.warehouse",
          path: "warehouse_name",
          required: true,
        },
        {
          labelKey: "common.product",
          path: "product_name",
          required: true,
        },
        {
          labelKey: "stock_management.storage_losses.engineer",
          path: "engineer_name",
          required: true,
        },
        {
          labelKey: "stock_management.storage_losses.warehouse_manager",
          path: "warehouse_manager_name",
          required: true,
        },
        {
          labelKey: "stock_management.storage_losses.loss_quantity",
          path: "rows",
          required: true,
          formatter: (rows) => this.calculateTotalQty(rows),
        },
      ];
    },
  },
  methods: {
    calculateTotalQty(rows) {
      const list = Array.isArray(rows) ? rows : [];
      return parseFloat(list.reduce((sum, row) => sum + Number(row?.loss_quantity || 0), 0).toFixed(2));
    },
  },
};
</script>
